// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__r4ELY","wrapper":"Home_wrapper__U7UwZ","left":"Home_left__ZuaWo","right":"Home_right__2FoHW"};